import React from "react";

const MissionStatementSection = () => {
  return (
    <section className="2xl:h-[calc(100vh-96px)] h-[calc(100vh-75px)] pt-24 pb-8 md:pb-[5rem] w-full flex flex-col items-center justify-center px-0 md:px-24 bg-white snap-start transition-all duration-700">
      <div className="w-[70%] text-center mx-auto 2xl:pt-16 pb-12 relative px-5 2xl:px-0">
        <img
          src="/quote-top.svg"
          alt="Background"
          className="absolute md:block top-[-40px] md:top-0 2xl:top-14 left-[-25px] md:left-0 w-18 object-cover"
        />
        <img
          src="/quote-bottom.svg"
          alt="Background"
          className="absolute md:block bottom-[80px] md:bottom-16 2xl:bottom-24 right-[-25px] md:right-0 w-18 object-cover"
        />
        <h1 className="text-xl md:text-2xl 2xl:text-3xl font-semibold text-gray-800 mb-8 2xl:mb-12 text-center">
          Empowering changemakers with an intuitive,
          <br /> purpose-built workspace that helps them fulfill their vision.
        </h1>
        <p className="text-[#656F84] text-sm md:text-base 2xl:text-lg text-center mb-12 2xl:mb-16 px-3 md:px-0">
          We serve as the backbone of impact creation—simplifying complexity,
          enhancing collaboration,
          <br /> delivering data-driven insights, and enabling seamless
          communication.
        </p>
        <hr className="w-[100%] md:w-[45%] mx-auto border-t-[2px] md:border-t" />
      </div>{" "}
    </section>
  );
};

export default MissionStatementSection;
